import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProfileApiService } from '@modules/profile/profile-api.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { AppState } from '@shared/redux/config-store-state.model';
import { SeoMetadataService } from '@shared/services/seo-metadata.service';
import { configAction, updateUser } from '@shared/redux/actions/actions-store-state.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'astrea-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {

  public openComponent!: string;
  public user!: any;
  public isUserShared = false;

  public loadingPage = true;

  private subsUser$!: Subscription;

  constructor(
    private seo: SeoMetadataService,
    private api: ProfileApiService,
    private route: ActivatedRoute,
    private location: Location,
    private store: Store<AppState>,
  ) { }

  ngOnInit(): void {
    this.setMetadata();
    const profile = this.route.snapshot.paramMap.get('profile');
    if (!profile)
      this.startProfilePage('personal');
    if (profile && (profile == 'personal' || profile == 'invoicing' || profile == 'config' || profile == 'security'))
      this.startProfilePage(profile);
  }

  ngOnDestroy(): void {
    if (this.subsUser$) this.subsUser$.unsubscribe();
  }


  setMetadata(): void {
    this.seo.setMetadata({
      title: 'Perfil de usuario',
      description: 'Datos personales del usuario y configuraciones de la cuenta.',
      relativeUrl: '/profile',
      shouldIndex: false,
    });
  }

  startProfilePage(p: string): void {
    this.openComponent = p;
    this.subsUser$ = this.store.select(state => state.storeUser)
      .subscribe({
        next: userData => {
          this.user = userData.user;
          if (this.user) {
            this.loadingPage = false;
            const entityuser = userData.user.entityuser;
            this.isUserShared = (entityuser == 'IP' || entityuser == 'FOREIGN') ? true : false;
          }
          else
            this.getUserIfNotExist();
        }
      });
  }

  getUserIfNotExist(): void {
    this.api.getUser()
      .subscribe({
        next: res => {
          this.store.dispatch(updateUser({ user: res.result.data }));
          this.store.dispatch(configAction({
            darkMode: res.result.data.darkmode,
            language: res.result.data.language,
            currency: res.result.data.currency
          }));
          this.loadingPage = false;
        },
        error: () => {
          /*
            Si el usuario no existe, queda la sesión abierta.
            Verificar acá, en AppConfigService & CartComponent
          */
        }
      });
  }

  handleOpenComponent(component: string): void {
    this.openComponent = component;
    this.location.go(`profile/${component}`);
  }

}
